import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { WebPickupPointDto } from './WebPickupPointDto'
import { DeliveryMethodKind } from './Enums'
/**
* Class WebChannelDeliveryMethodDto
*  Публичная карточка способа доставки в config
*/
export class WebChannelDeliveryMethodDto extends ActiveModel {

  /**
  * id
  *   */
  @ActiveField(0)
  id: number = 0


  /**
  * kind
  * словарь значений публикуется под именем `Domain.Entities.Channels.DeliveryMethodKind`  *   * Вид способа.  *   * - `Cdek` СДЭК  *   * Интеграция СДЭК (не более одной записи на канал).  * - `Pickup` Самовывоз  *   * Самовывоз со склада (не более одной записи на канал).  * - `Manual` Без интеграции  *   * Способ без интеграции API (может быть несколько на канал).  *   */
  @ActiveField(DeliveryMethodKind.CDEK)
  kind: DeliveryMethodKind = DeliveryMethodKind.CDEK


/**
  * name
  * Отображаемое название.
  */
  @ActiveField('')
  name: string = ''


  /**
  * order
  *   */
  @ActiveField(0)
  order: number = 0


/**
  * @property pickupPoints
  * Точки выдачи. Заполняется только для Domain.Entities.Channels.DeliveryMethodKind.Pickup:<br>покупателю нужно видеть, куда ехать, до оформления заказа.<br>  */
  @ActiveField({
    factory: [WebPickupPointDto, () => undefined]
  })
  pickupPoints?: null | Array<WebPickupPointDto>
}
